import { IconProps } from '@televet/kibble-ui/build/components/Icon';
import { TypographyVariant } from '@televet/kibble-ui/build/shared/types';
import { CancelReasonType, CareSubscriptionPaymentStatus, RenewalRejectionReason } from 'shared/types/graphql';
import { EnrollmentEventType, ActivityLogManageMembershipRequests, CareEnrollmentPaymentDataType } from '../types';

export const EnrollmentEventIcon: Record<EnrollmentEventType, IconProps> = {
  MembershipStarted: {
    name: 'starSolid',
    variant: 'success',
  },
  MembershipEnded: {
    name: 'cancel',
    variant: 'danger',
  },
  MembershipRenewed: {
    name: 'arrowCircle',
    variant: 'success',
  },
  RenewalEmail: {
    name: 'envelope',
    variant: 'default',
  },
};

export const EnrollmentSupportEventProps: Record<ActivityLogManageMembershipRequests, IconProps> = {
  Cancel: {
    name: 'cancel',
    variant: 'danger',
  },
  OptOut: {
    name: 'cancel',
    variant: 'danger',
  },
  Transfer: {
    name: 'transfer',
    variant: 'success',
  },
  Upgrade: {
    name: 'moveUp',
    variant: 'success',
  },
  Note: {
    name: 'penSquare',
    variant: 'default',
  },
};

export const CareEnrollmentPaymentIcon: Record<
  CareSubscriptionPaymentStatus | CareEnrollmentPaymentDataType,
  IconProps
> = {
  Paid: {
    name: 'dollarCircle',
    variant: 'success',
  },
  PastDue: {
    name: 'warningSign',
    variant: 'danger',
  },
  Draft: {
    name: 'warningSign',
    variant: 'danger',
  },
  Open: {
    name: 'warningSign',
    variant: 'danger',
  },
  Dispute: {
    name: 'warningSign',
    variant: 'danger',
  },
  Refund: {
    name: 'dollarCircle',
    variant: 'success',
  },
  Payment: {
    name: 'dollarCircle',
    variant: 'success',
  },
};

export const ReadableEnrollmentEventType: Record<EnrollmentEventType, string> = {
  MembershipStarted: 'Membership Started',
  MembershipEnded: 'Membership Ended',
  MembershipRenewed: 'Membership Renewed',
  RenewalEmail: 'Renewal Email',
};

export const TextColorByEnrollmentEventType: Record<EnrollmentEventType, TypographyVariant> = {
  MembershipStarted: 'success',
  MembershipEnded: 'danger',
  MembershipRenewed: 'success',
  RenewalEmail: 'default',
};

export const ReadableEnrollmentSupportEvent: Record<ActivityLogManageMembershipRequests, string> = {
  Cancel: 'Membership Cancelled',
  OptOut: 'Renewal Opt-Out',
  Transfer: 'Membership Transferred',
  Upgrade: 'Membership Upgraded',
  Note: 'Note Added',
};

export const ReadableRenewalRejectionReason: Record<RenewalRejectionReason, string> = {
  [RenewalRejectionReason.DeceasedPet]: 'Deceased Pet',
  [RenewalRejectionReason.OptOut]: 'Renewal Opt-Out',
  [RenewalRejectionReason.PaymentsMissing]: 'Missed Payments',
};

export const ReadableCancelReason: Record<CancelReasonType, string> = {
  DeceasedPet: 'Deceased Pet',
  ChangedMind: 'Changed Mind',
  Moving: 'Moving',
  FinancialHardship: 'Financial Hardship',
  PetRehomed: 'Pet Re-Homed',
  Other: 'Other',
  ClinicInitiatedOther: 'Clinic Initiated - Other',
  ClinicInitiatedUncollectible: 'Clinic Initiated - Uncollectible',
};
